// extracted by mini-css-extract-plugin
export var image = "EventFormat-module--image--af1b2";
export var item = "EventFormat-module--item--8ae18";
export var list = "EventFormat-module--list--2e90d";
export var media = "EventFormat-module--media--499e3";
export var name = "EventFormat-module--name--51e2e";
export var row = "EventFormat-module--row--c6ed1";
export var section = "EventFormat-module--section--057df";
export var time = "EventFormat-module--time--b8871";
export var title = "EventFormat-module--title--984d5";